import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DeliveryDate } from '@aid/product-contract/types/classes';

@Component({
  selector: 'aid-product-contract-delivery-date-dialog',
  template: `
    <aid-dialog [title]="'delivery-date'" (close)="onClose()">
      <div class="aid-layout-column aid-layout-gap-32">
        <span class="mat-subtitle-2 basic-color-900">{{
          'change-delivery-date' | translate | sentancecase
        }}</span>
        <aid-product-contract-delivery-date-form
          (cancel)="onClose()"
          (submit)="onSubmit($event)"
        >
        </aid-product-contract-delivery-date-form>
      </div>
    </aid-dialog>
  `,
  styleUrls: ['./product-contract-delivery-date-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ProductContractDeliveryDateDialogComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ProductContractDeliveryDateDialogComponent>
  ) {}

  ngOnInit() {}

  onClose() {
    this.dialogRef.close();
  }

  onSubmit(deliveryDate: DeliveryDate) {
    this.dialogRef.close(deliveryDate);
  }
}
